<template>
  <div>
    <van-field required :rules="!disabled ? [{ validator:validatorGtMaterial, message: '请选择罐体材质' }] : []" input-align="right" :right-icon="disabled ? '' : 'arrow'" readonly clickable name="picker" :value="gtMaterial" label="罐体材质" placeholder="点击选择罐体材质" @click="!disabled && showPickerBtn()"/>
    <van-popup v-model="showPicker" position="bottom" @close="closePopup">
      <van-picker show-toolbar :columns="guanticaizhiTypeList" @confirm="onConfirm" @cancel="showPicker = false"/>
    </van-popup>
  </div>
</template>
<script>
import { Toast } from "vant";
import api from "@/fetch/api";
import store from "@/store"

export default{
  props: {
    gtMaterial:{
      type: String,
      default: ""
    },
    isRequire:{
      type:Boolean,
      default:true,
    },
    disabled:{
      type:Boolean,
      default:false,
    },
  },
  data(){
    return {
      showPicker:false,
      guanticaizhiTypeList:[],
    }
  },
  created()
  {
    this.getGtMaterial();
  },
  methods:{
    closePopup() {
      this.$emit('close')
    },
    getGtMaterial()
    {
      var that = this;
      var typeGroupName = "guanticaizhi";
      api.getTypeList(typeGroupName).then(function(res) {
        var resData = JSON.parse(res);
        if (resData.success == true) {
          var result = resData.obj;
          var guanticaizhiTypeList = [];
          result.forEach((item) => {
            if(item.typename) guanticaizhiTypeList.push(item.typename);
          });
          that.guanticaizhiTypeList = guanticaizhiTypeList;
        } else {
          Toast.fail(resData.message);
        }
      }).catch(function(err) {
        console.log(err);
      });
    },
    showPickerBtn()
    {
      this.showPicker = true;
      store.state.isFirstTime && this.$driverObj.destroy()
    },
    validatorGtMaterial(val)
    {
      if(this.gtMaterial)
      {
        if (!val) {
          Toast.fail('请选择罐体材质' );
          return false;
        }
        return val;
      }
    },
    onConfirm(value)
    {
      this.$emit("changeGtMaterial",value);
      this.showPicker = false;
    },
  },
}
</script>
<style lang="scss" scoped>

</style>
